import { datadogLogs } from "@datadog/browser-logs";
import { PopupEvent } from "@redotech/redo-onboarding-common/popup-events";
import { FeatureOnboardingType } from "@redotech/redo-onboarding-common/user-onboarding";

/**
 * Whether a manager-selected popup actually reached the merchant. Selection
 * alone is not enough: mobile, automated sessions, and some routes render null.
 */
export function isPopupVisibleToMerchant(input: {
  /** False when `index.tsx` rendered null — mobile, webdriver, or no match. */
  hasCard: boolean;
  routeSuppressed: boolean;
  managedReturnsTrialPreview: boolean;
  /** The type rendered, not the one selected: manual opens dismiss too. */
  renderedType: FeatureOnboardingType | undefined;
}): boolean {
  return (
    input.hasCard &&
    !input.routeSuppressed &&
    !input.managedReturnsTrialPreview &&
    !!input.renderedType &&
    input.renderedType !== FeatureOnboardingType.DISABLED
  );
}

/**
 * A completed popup cannot also have been dismissed. Accept handlers commonly
 * close the modal too, which would count every acceptance as a dismissal.
 */
export function shouldEmitPopupEvent(
  event: PopupEvent,
  acceptedSinceShown: ReadonlySet<FeatureOnboardingType>,
  type: FeatureOnboardingType,
): boolean {
  return !(event === PopupEvent.DISMISSED && acceptedSinceShown.has(type));
}

export function trackPopupEvent(
  event: PopupEvent,
  popupType: FeatureOnboardingType,
  teamId: string | undefined,
): void {
  // `event` is repeated into the attributes so Datadog can facet on `@event`
  // rather than matching on log message text. `popupType` is the facet the
  // admin popup-analytics query groups by.
  datadogLogs.logger.info(event, { event, popupType, teamId });
}
